import { useState } from "react";
import { useIntl } from "react-intl";

export function Dimensions({
	dimensionsAndOptions,
	register,
	getValues,
	errors,
}: {
	dimensionsAndOptions: {
		dimensionId: string;
		localizedValue: string;
		isDimensionTextBox: boolean;
		options: {
			optionId: string;
			localizedValue: string;
			isTextbox: boolean;
		};
	}[];
	register: any;
	getValues: any;
	errors: any;
}) {
	const [selectedOptions, setSelectedOptions] = useState<{
		[key: string]: any;
	}>({});

	const intl = useIntl();
	if (!dimensionsAndOptions || dimensionsAndOptions.length === 0) return <></>;

	const values = getValues();
	dimensionsAndOptions = dimensionsAndOptions.filter((f) => {
		// @ts-expect-error
		if (!f.isDimensionTextBox && f.options?.length == 0) return false;
		return true;
	});

	return (
		<div style={{ backgroundColor: "#fcfcfc" }} className="p-2 border w-100 rounded">
			{Object.values(dimensionsAndOptions).map((dim: any) => {
				const isDimensionTextBox = dim.isDimensionTextBox;
				const isDimensionTextId = dim.options[0]?.optionId;

				const selectedDimensionsValue = values[`dimensions`] ?? {};
				const selectedOption = dim.options.find(
					(opt: any) =>
						String(opt.optionId) === String(selectedDimensionsValue[`dim_${dim.dimensionId.toString()}`]),
				);
				console.log(">>>> dim.options", dim, selectedOption)

				return (
					<div key={dim.dimensionId}>
						<label className="form-label">{dim.localizedValue}</label>
						{!isDimensionTextBox ? (
							<>
								<select
									{...register(`dimensions.dim_${dim.dimensionId.toString()}`)}
									className="form-select"
									onChange={(e) => {
										const selectedOption = dim.options.find(
											(opt: any) => String(opt.optionId) === e.target.value,
										);

										setSelectedOptions((prev) => ({
											...prev,
											[dim.dimensionId]: selectedOption,
										}));
										// If you want to trigger a re-render for textbox, you may need to use state
										// or useForm's setValue/watch, but for now just let react-hook-form handle value
										register(`dimensions.dim_${dim.dimensionId.toString()}`).onChange(e);
									}}
								>
									<option value="">{intl.formatMessage({ id: "select" })}</option>
									{dim.options.map((opt: any) => {
										return (
											<option key={opt.optionId} value={opt.optionId}>
												{opt.localizedValue} {opt.isTextbox}
											</option>
										);
									})}
								</select>
								{selectedOption?.isTextbox && (
									<input
										type="text"
										className="form-control mt-2"
										placeholder={intl.formatMessage({ id: "enter_value" })}
										{...register(`dimensions.dim_${dim.dimensionId.toString()}_text`)}
									/>
								)}

								{errors.subcategory && (
									<small className="text-danger">{errors.subcategory.message as string}</small>
								)}
							</>
						) : (
							<>
								<input
									type="text"
									className="form-control"
									{...register(`dimensions.dim_${dim.dimensionId}_${isDimensionTextId}_freetext`)}
									placeholder={intl.formatMessage({ id: "enter_value" })}
								/>
							</>
						)}
					</div>
				);
			})}
		</div>
	);
}
